define([
    'handlebars',
    'modules/common/controls/control'
], (Handlebars, Control) => {
    const helpers = Handlebars.helpers;

    return Control.extend({
        tagName: 'span',

        binders: {
            value: {
                bind (view, publish) {
                    this.callback = function () {
                        publish(view.get());
                    };
                    view.on('change', this.callback);
                },
                unbind (view) {
                    view.off('change', this.callback);
                },
                routine (view, value) {
                    view.$el.html(helpers.h_date_plain(_.escape(value)));
                }
            }
        }
    });
});
